// extracted by mini-css-extract-plugin
export default {"alertMessages":"Notification_alertMessages__F1GSc","alertBoxes":"Notification_alertBoxes__QOZvj"};